import { createAsyncThunk } from "@reduxjs/toolkit";
import * as APICalls from "../../../utils/APICalls/APICalls";

export const getReferralCode = createAsyncThunk(
  "fetchCustomerReferralCode",
  async (restaurantId: number) => {
    const referralCode = await APICalls.getReferralCode(restaurantId);

    return referralCode.data;
  }
);
